<template>
    <div v-if="procedimento && procedimento.prazos">
        <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between" v-for="(prazo, ipx) in lista" :key="ipx">
                <div>
                    <a href="#" @click.prevent="editar(prazo)" class="card-link">
                        {{ prazo.search }}
                    </a>

                    <span class="badge badge-secondary ml-2">#{{ prazo.id_procedimento_prazo }}</span>
                    
                    <span class="badge badge-secondary ml-2">
                        <i class="fa fa-sort" aria-hidden="true"></i>
                        {{ prazo.in_regra_ordem }}
                    </span>

                    <span class="badge badge-danger ml-2" v-if="!prazo.fl_ativo">Inativo</span>
                </div>
                <div>
                    {{ prazo.texto_prazo }}
                </div>
            </li>
        </ul>

        <button type="button" class="btn btn-outline-primary mt-2" @click="incluir()">
            <i class="fa fa-plus" aria-hidden="true"></i>
        </button>

        <!-- Cadastro -->
        <div class="modal fade" id="procPrazoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Prazo {{ edicao.id_procedimento_prazo ? ' #' + edicao.id_procedimento_prazo : ' Novo' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input v-model="edicao.st_titulo" label="Título" :validate="validate" required></az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class='col col-12 col-md-4'>
                                <az-input
                                    type="select"
                                    label="Urgência"
                                    :optionsList="[
                                        { id: 'N', search: 'Apenas Não Urgentes' },
                                        { id: 'S', search: 'Apenas Urgentes' },
                                        { id: 'T', search: 'Urgentes/Não Urgentes' },
                                    ]"
                                    optionsData="id"
                                    required
                                    :validate="validate"
                                    v-model="edicao.ch_urgente" />
                            </div>
                            <div class='col col-12 col-md-4'>
                                <az-input
                                    type="number"
                                    label="Prazo"
                                    required
                                    :validate="validate"
                                    v-model="edicao.in_prazo_entrega" />
                            </div>
                            <div class='col col-12 col-md-4' v-if="edicao.in_prazo_entrega">
                                <az-input
                                    type="select"
                                    label="Referência do Prazo"
                                    placeholder="Selecione..."
                                    optionsData="id"
                                    :optionsList="[
                                        { id: 'days', search: 'dias' },
                                        { id: 'hours', search: 'horas' },
                                    ]"
                                    required
                                    :validate="validate"
                                    v-model="edicao.st_tempo_prazo_entrega" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input v-model="edicao.st_observacoes" label="Observações" :validate="validate" type="textarea" rows="3"></az-input>
                            </div>
                        </div>

                        <div class="form-row mt-3" v-if="edicao.id_procedimento_prazo">
                            <div class="col col-12">
                                <az-input   
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Ativo"
                                    v-model="edicao.fl_ativo" />
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="edicao.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <br><br><br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">{{ edicao.id_procedimento_prazo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data() {
        return {
            validate: false, 
            edicao: null, 
        }
    },
    
    components: {
        AzInput,
        AzSubmit,
        FiltroModel,
    },

    computed: { 
        lista: function() {
            if ( !this.procedimento || !this.procedimento.prazos ) { 
                return []; 
            }

            return this.procedimento.prazos;
        }, 

        lista_opcoes_filtro: function () {
            return [
                {id:'App\\azure\\apoiado', search:'Apoiado', service: 'apoiados.index'}, 
                {id:'App\\azure\\apoiadoOrigem', search:'Apoiado - Origem', service:'apoiado_origens.index', parms: { lista_filtro: true }},
                {id:'tag-apoiado', search:'Classificação da Apoiado', service: 'apoiados.index', tag: true},
                {id:'tag-operadora', search:'Classificação da Operadora', service: 'operadoras.index', tag: true},
                {id:'tag-unidade', search:'Classificação da Unidade', service: 'unidade_operacaos.index', tag: true}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'},
            ];
        },
    },

    props: ['procedimento'], 

    methods: { 
        editar (prazo) { 
            this.edicao = _.cloneDeep(prazo); 
            $('#procPrazoModal').modal('show');
        },

        incluir() { 
            this.edicao = {
                id_procedimento: this.procedimento.id_procedimento, 
                st_titulo: "", 
                in_prazo_entrega: 1, 
                st_tempo_prazo_entrega: "days", 
                in_regra_ordem: 100,
                fl_ativo: true, 
                st_observacoes: "", 
                ch_urgente: 'T', 
                filtros: [], 
            }; 
            $('#procPrazoModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'procedimento_prazos', 
                func: 'store',
                dados: this.edicao,
                toast: true, 
                modal: 'procPrazoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>
